import React, { useState } from 'react';
import Styled from 'styled-components';
import propTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import { useAuth } from '../../Contexts/AuthContext';
import { StyledButton } from '../../Components/Generics.styled';

const WelcomeText = Styled.div`
text-align: center;
letter-spacing: 0px;
color: #000000;
opacity: 1;
font-size: 23px;
font-weight: bold;
`;

const PlanContainer = Styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const CardContainer = Styled.div`
max-width: 1400px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 500px) {
    flex-direction: column;

    }

`;

const StyledCard = Styled.div`
height: 420px;
width: 100%;
border-radius: 12px;
border: 1px solid black;
padding: 12px;

@media only screen and (max-width: 500px) {
    margin-bottom: 20px;

    }
`;

const StyledNavButtons = Styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const Card = (props) => {
    const {
        planTypeStyle,
        planType,
        description,
        planPriceMonthly,
        planPriceAnually,
        onCheckBoxChangeMonthly,
        onCheckBoxChangeAnnually,
        adDescription,
        isCheckedMonthly,
        isCheckedAnually,
    } = props;

    return (
        <StyledCard>
            <div style={planTypeStyle}>{planType}</div>
            <div style={{ display: 'flex', borderBottom: '1px solid black' }}>
                <div
                    style={{
                        fontSize: '14px',
                        color: '#0F2CFB',
                        width: '250px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {planPriceMonthly}
                </div>
                <div style={{ height: '40px', marginBottom: '5px' }}>
                    <Checkbox
                        checked={isCheckedMonthly}
                        onChange={onCheckBoxChangeMonthly}
                        name={`${planType}-monthly`}
                    />
                </div>
            </div>
            <br />

            <div style={{ display: 'flex', borderBottom: '1px solid black' }}>
                <div
                    style={{
                        fontSize: '14px',
                        color: '#0F2CFB',
                        width: '250px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {planPriceAnually}
                    <div style={{ color: 'black', fontSize: '12px', fontStyle: 'italic' }}>
                        {adDescription}
                    </div>
                </div>
                <div style={{ height: '0px', marginBottom: '5px' }}>
                    <Checkbox
                        checked={isCheckedAnually}
                        onChange={onCheckBoxChangeAnnually}
                        name={`${planType}-annually`}
                    />
                </div>
            </div>

            <br />
            <div
                style={{
                    maxWidth: '290px',
                    wordWrap: 'break-word',
                }}
            >
                <div style={{ fontWeight: '500', fontSize: '18px' }}>Suitable for:</div>
                <div style={{ fontSize: '14px' }}>
                    {description.map((item, idx) => (
                        <li style={{ paddingLeft: '20px' }} key={idx}>
                            {item}
                        </li>
                    ))}
                </div>
            </div>
        </StyledCard>
    );
};

Card.propTypes = {
    planTypeStyle: propTypes.shape({}),
    planType: propTypes.string,
    description: propTypes.array,
    planPriceMonthly: propTypes.string,
    planPriceAnually: propTypes.string,
    onCheckBoxChangeMonthly: propTypes.func,
    onCheckBoxChangeAnnually: propTypes.func,
    adDescription: propTypes.string,

    isCheckedMonthly: propTypes.bool,
    isCheckedAnually: propTypes.bool,
};

Card.defaultProps = {
    planTypeStyle: {},
    planType: '',
    description: [],
    planPriceMonthly: '',
    planPriceAnually: '',
    adDescription: '',
    onCheckBoxChangeMonthly: () => {},
    onCheckBoxChangeAnnually: () => {},

    isCheckedMonthly: false,
    isCheckedAnually: false,
};

const TellUsAboutYourBusinessPlan = ({ history, planTypeData }) => {
    const initialState = {
        Basic: {
            monthly: false,
            annually: false,
        },
        Essentials: {
            monthly: false,
            annually: false,
        },
        Pro: {
            monthly: false,
            annually: false,
        },
        AgencyPro: {
            monthly: false,
            annually: false,
        },
    };

    const { currentUser } = useAuth();
    const { user, isVerified } = { ...currentUser };

    const [checkboxVal, setCheckboxVal] = useState(initialState);
    const [selectedPlan, setSelectedPlan] = useState({ planName: '', duration: '', price: '' });

    const { Basic, Essentials, Pro, AgencyPro } = { ...checkboxVal };

    const handleNavNextClick = () => {
        localStorage.setItem('planTypeId', selectedPlan.planTypeId);
        localStorage.setItem('planTypeName', selectedPlan.planName);
        localStorage.setItem('planTypeDuration', selectedPlan.duration);
        localStorage.setItem('planTypePrice', selectedPlan.price);

        if (user && isVerified) {
            history.push('/aboutYourBusiness/form');
        } else {
            history.push('/signup');
        }
    };

    const getValueFromData = (planName) =>
        planTypeData.find((item) => {
            if (item.name === planName) {
                return true;
            }
            return false;
        });

    const handleCheckboxValMonthly = (item) => {
        if (item.name === 'Pro') {
            setCheckboxVal({ ...initialState, Pro: { monthly: true, annually: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'monthly',
                price: getValueFromData(item.name).monthlyFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }
        if (item.name === 'AgencyPro') {
            setCheckboxVal({ ...initialState, AgencyPro: { monthly: true, annually: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'monthly',
                price: getValueFromData(item.name).monthlyFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }
        if (item.name === 'Essentials') {
            setCheckboxVal({ ...initialState, Essentials: { monthly: true, annually: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'monthly',
                price: getValueFromData(item.name).monthlyFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }
        if (item.name === 'Basic') {
            setCheckboxVal({ ...initialState, Basic: { monthly: true, annually: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'monthly',
                price: getValueFromData(item.name).monthlyFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }
    };

    const handleCheckboxAnually = (item) => {
        if (item.name === 'Pro') {
            setCheckboxVal({ ...initialState, Pro: { annually: true, monthly: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'annually',
                price: getValueFromData(item.name).annualFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }
        if (item.name === 'AgencyPro') {
            setCheckboxVal({ ...initialState, AgencyPro: { annually: true, monthly: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'annually',
                price: getValueFromData(item.name).annualFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }
        if (item.name === 'Essentials') {
            setCheckboxVal({ ...initialState, Essentials: { annually: true, monthly: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'annually',
                price: getValueFromData(item.name).annualFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }

        if (item.name === 'Basic') {
            setCheckboxVal({ ...initialState, Basic: { annually: true, monthly: false } });
            setSelectedPlan({
                planName: getValueFromData(item.name).name,
                duration: 'annually',
                price: getValueFromData(item.name).annualFee,
                planTypeId: getValueFromData(item.name).planTypeId,
            });
        }
    };

    function numberWithCommas(x) {
        return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const disableNextButton =
        Basic.monthly === false &&
        Basic.annually === false &&
        Essentials.monthly === false &&
        Essentials.annually === false &&
        Pro.monthly === false &&
        Pro.annually === false &&
        AgencyPro.monthly === false &&
        AgencyPro.annually === false;
    return (
        <PlanContainer>
            <WelcomeText>Choose the plan that&apos;s right for your business</WelcomeText>
            <br />
            <CardContainer>
                {planTypeData?.map((item, idx) => (
                    <div key={idx}>
                        <Card
                            planType={item.name === 'AgencyPro' ? 'Agency Pro' : item.name}
                            planPriceMonthly={`$${numberWithCommas(
                                item?.monthlyFee?.toFixed(2)
                            )}/ month (${item.minMonthsToCommit} months min) + ${
                                item?.discount
                            }% of media buy`}
                            planPriceAnually={`$${numberWithCommas(
                                item?.annualFee?.toFixed(2)
                            )} Annual Fee (pay ${
                                item?.advanceNeededMonths / 12
                            } year in advance) + ${item?.discount}% of media buy`}
                            adDescription={`${item?.freeMonths} months free advertising up to ${item?.freeAds} ads on DavieDeals.`}
                            planTypeStyle={{ fontSize: '24px' }}
                            description={item?.suitableFor}
                            onCheckBoxChangeMonthly={() => handleCheckboxValMonthly(item)}
                            onCheckBoxChangeAnnually={() => handleCheckboxAnually(item)}
                            isCheckedMonthly={
                                item?.name === selectedPlan?.planName &&
                                checkboxVal[selectedPlan?.planName].monthly === true
                            }
                            isCheckedAnually={
                                item.name === selectedPlan.planName &&
                                checkboxVal[selectedPlan.planName].annually === true
                            }
                        />
                    </div>
                ))}
            </CardContainer>
            <StyledNavButtons>
                <StyledButton
                    disabled={disableNextButton}
                    onClick={() => handleNavNextClick()}
                    variant="contained"
                    color="primary"
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </PlanContainer>
    );
};
TellUsAboutYourBusinessPlan.propTypes = {
    history: propTypes.shape({
        push: propTypes.func,
    }),

    planTypeData: propTypes.arrayOf(propTypes.shape({})),
};

TellUsAboutYourBusinessPlan.defaultProps = {
    history: {},

    planTypeData: [],
};
export default TellUsAboutYourBusinessPlan;
